/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/htp/HtpTile',['pixi', 'absolute', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile', 'util/CustomWordWrapper'],

    function (PIXI, Absolute, _, SolitaireGameMode, MenuTile, CustomWordWrapper) {

        var HtpTile = function (config, isFirst) {
            var defaultConfig = { "wideTile": false };
            this.initHtpTile(_.extend(defaultConfig, config), isFirst);
        };

        HtpTile.prototype = Object.create(MenuTile.prototype);

        HtpTile.prototype.initHtpTile = function (config, isFirst) {

            MenuTile.call(this, config);

            var hr = new PIXI.Graphics(),
                hrWidth = Absolute.Platform.isMobile() ?
                    (this.config.wideTile ? Absolute.Coords.x(945 * 1.7) : Absolute.Coords.x(460 * 2)) :
                    (this.config.wideTile ? Absolute.Coords.x(945) : Absolute.Coords.x(420)),
                padding = Absolute.Platform.isMobile() ? Absolute.Coords.x(10 * 2) : Absolute.Coords.x(10),

                textWidth = hrWidth - padding * 2,

                lineWeight = Absolute.Platform.isMobile() ?
                    isFirst ? Absolute.Coords.x(4 * 2) : Absolute.Coords.x(2 * 2) :
                    isFirst ? Absolute.Coords.x(4) : Absolute.Coords.x(2),

                columnX = Absolute.Platform.isMobile() ?
                    this.config.wideTile ? Absolute.Coords.x(0) : Absolute.Coords.x(320 * 2 + padding) :
                    this.config.wideTile ? Absolute.Coords.x(600) : Absolute.Coords.x(320),

                columnY = Absolute.Platform.isMobile() ?
                    (this.config.wideTile ? Absolute.Coords.y(850) : Absolute.Coords.y(20)) :
                    Absolute.Coords.y(20),

                font = isFirst ? Absolute.ScreenMetrics.getResScale() * 35 * (Absolute.Platform.isMobile() ? 2 : 1) + 'px Arial' :
                    Absolute.ScreenMetrics.getResScale() * 30 * (Absolute.Platform.isMobile() ? 2 : 1) + 'px Arial',

                headlineStyle = {
                    font: font,
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'center'
                },
                descriptionStyle = {
                    font: Absolute.ScreenMetrics.getResScale() * 23 * (Absolute.Platform.isMobile() ? 2 : 1) + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left',
                    wordWrap: true,
                    wordWrapWidth: textWidth
                },

                headline = new PIXI.Text(this.config.headline, headlineStyle),
                description = new PIXI.Text(this.config.description, descriptionStyle);

            Absolute.StringManager.shrinkToFit(
                description,
                Absolute.ScreenMetrics.getResScale() * 23 * (Absolute.Platform.isMobile() ? 2 : 1),
                '', null,
                Absolute.Coords.y(this.height - 100) * (Absolute.Platform.isMobile() ? 1.5 : 1));
            Absolute.StringManager.shrinkToFit(
                headline,
                Absolute.StringManager.extractNumbersFromString(font),
                '', Absolute.Coords.x(400) * (Absolute.Platform.isMobile() ? 2 : 1));

            headline.x = columnX + padding;
            headline.y = columnY + padding;
            this.addChild(headline);

            hr.moveTo(0, 0);
            hr.lineStyle(lineWeight, 0xffffff, 1);
            hr.lineTo(hrWidth, 0);
            hr.x = columnX + padding;
            hr.y = Absolute.Platform.isMobile() ?
                columnY + (isFirst ? Absolute.Coords.y(60 * 2) : Absolute.Coords.y(55 * 2)) :
                isFirst ? Absolute.Coords.y(65) : Absolute.Coords.y(60);
            this.addChild(hr);

            description.x = columnX + padding;
            description.y = Absolute.Platform.isMobile() ?
                columnY + (isFirst ? Absolute.Coords.y(75 * 2) : Absolute.Coords.y(70 * 2)) :
                (isFirst ? Absolute.Coords.y(75) : Absolute.Coords.y(70));

            this.addChild(description);

            this.interactive = false;
            this.buttonMode = false;

            this._hasFocus = false;
            this.focusIndicator = new PIXI.Graphics();
            this.focusIndicator.lineStyle(Absolute.Coords.x(3), 0xFFFFFF);
            var margin = Absolute.Coords.x(-4);
            this.focusIndicator.drawRect(margin, margin, this.width - 2 * margin, this.height - 2 * margin);
            CustomWordWrapper.doTextCustomWrap(
                description, Absolute.ScreenMetrics.getResScale() * 23,
                '', textWidth, Absolute.Coords.y(this.height - 50)
            );
        };

        HtpTile.prototype.handleClick = function () {
            //console.log('ignore htp click');
        };

        HtpTile.prototype._focusChanged = function () {
            if (this._hasFocus) {
                this.addChild(this.focusIndicator);
            } else {
                if (this.children.indexOf(this.focusIndicator) !== -1) {
                    this.removeChild(this.focusIndicator);
                }
            }
        };

        Object.defineProperty(HtpTile.prototype, "focus", {
            get: function () {
                return this._hasFocus;
            },
            set: function (value) {
                this._hasFocus = value;
                this._focusChanged();
                return value;
            }
        });

        return HtpTile;

    });

